import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Tooltip } from '@vds/core';
import Text from '../../typography/text/index.js';
import styles from './cap.module.scss.js';

const Cap = (props) => {
    const { iconAlignment = 'middle', sidePadding = '24px', verticalPadding = '12px', backgroundColor = 'red', elementColor = 'red', height = '48px', maxHeight = '48px', tooltip, renderIcon, showBorder = false, bold = true, children, characterLimit, } = props;
    const containerStyles = [styles.container, styles[backgroundColor]];
    const iconStyles = [styles.icon];
    const childrenStyles = [styles.children];
    const childrenColor = backgroundColor === 'white'
        ? `var(--vds-color-${elementColor === 'red' ? 'standardred' : 'black'})`
        : 'var(--vds-color-white)';
    if (showBorder)
        containerStyles.push(styles.showBorder);
    if (iconAlignment === 'top' && renderIcon) {
        iconStyles.push(styles.alignTop);
        childrenStyles.push(styles.alignTop);
    }
    const clippedChildren = children && typeof children === 'string'
        ? String(children).slice(0, characterLimit)
        : children;
    const _threadSurface = () => {
        switch (backgroundColor) {
            case 'black':
                return 'darkPrimary';
            case 'white':
                return 'lightPrimary';
            case 'red':
            default:
                return 'darkBrandHighlight';
        }
    };
    const _renderTooltip = tooltip ? (jsx(Tooltip, Object.assign({ surface: _threadSurface(), iconColor: childrenColor }, tooltip))) : null;
    return (jsx("div", { className: containerStyles.join(' '), style: {
            padding: `${height === 'auto' && verticalPadding !== undefined ? verticalPadding : '0px'}  ${sidePadding} `,
            minHeight: height,
            maxHeight: height === 'auto' ? 'unset' : maxHeight,
            width: `calc(100% - ${sidePadding} * 2)`,
        }, children: jsxs("div", { className: styles.content, children: [jsx("div", { className: iconStyles.join(' '), children: renderIcon &&
                        renderIcon({
                            color: childrenColor,
                            surface: _threadSurface(),
                            size: 'medium',
                        }) }), jsx("div", { id: "text", className: childrenStyles.join(' '), style: { maxHeight }, children: jsx(Text, { size: "small", kind: "body", bold: bold, color: childrenColor, tooltip: undefined, children: clippedChildren }) }), jsx("div", { className: styles.tooltip, children: _renderTooltip })] }) }));
};

export { Cap as default };
